/* eslint-disable react-hooks/exhaustive-deps */
// This container displays the following
// 	- Graph title and the actual chart
// 	- Controls to resize the graph to
// 		- Fit tile area
// 		- Match Dashboard size
// 		- Full screen view
// 	- Also provides the sql query used to generate data for this graph
import { connect, useSelector } from 'react-redux';
import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { Dispatch } from 'redux';
import { setChartTitle, setGenerateTitle } from '../../redux/ChartPoperties/ChartPropertiesActions';
import { toggleGraphSize } from '../../redux/TabTile/TileActions';
import AreaChart from '../Charts/AreaChart';
import DoughnutChart from '../Charts/DoughnutChart';
import FunnelChart from '../Charts/FunnelChart';
import GaugeChart from '../Charts/GaugeChart';
import HeatMap from '../Charts/HeatMap';
import HorizontalBar from '../Charts/HorizontalBar';
import Horizontalstacked from '../Charts/Horizontalstacked';
import LineChart from '../Charts/LineChart';
import PieChart from '../Charts/PieChart';
import RoseChart from '../Charts/RoseChart';
import ScatterChart from '../Charts/ScatterChart';
import StackedBar from '../Charts/StackedBar';
import { MoreVertOutlined } from '@mui/icons-material';
import BarChartIcon from '@mui/icons-material/BarChart';
import Sankey from '../Charts/Sankey';
import WordCloudChart from '../Charts/WordCloudChart';
import TreeMap from '../Charts/TreeMap';
import BoxPlotChart from '../Charts/BoxPlotChart';
import CalendarChart from '../Charts/CalendarChart';
import StackedAreaChart from '../Charts/StackedAreaChart';
import MultiBarChart from '../Charts/MultiBarChart';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { AiFillFileExcel } from 'react-icons/ai';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import TextEditor from '../Charts/TextEditor/TextEditor';
import CrossTabChart from '../Charts/CrossTab/CrossTabChart';
import FilledMap from '../Charts/GeoChart/FilledMap';
import BubbleMap from '../Charts/GeoChart/BubbleMap';
import FetchData from '../ServerCall/FetchData';
import { toPng } from 'html-to-image';
import { getChartData } from '../ChartAxes/chartDataFunctions/getChartDataFunction';
import {
  callQueryAPI,
  removeColumnSecurityCard,
  removeRowSecurityCard,
  updateChartData,
  storeErrorDetails,
  updateChartMargins,
  updateLabelOption,
  updateQueryResult,
  updateUserSelection,
  updateUserSelectionColumn,
  resetExtraMeasureField,
} from '../../redux/ChartPoperties/ChartControlsActions';
import { Button, Popover } from '@mui/material';
import jsPDF from 'jspdf';
import DownloadPagePopover from '../CommonFunctions/PopOverComponents/DownloadPagePopover';
import {
  resetPageSettings,
  setPageSettings,
} from '../../redux/PageSettings/DownloadPageSettingsActions';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import sqlIcon from '../../assets/sqlCodeIcon.png';
import DoneIcon from '@mui/icons-material/Done';
import SimpleCard from '../Charts/SimpleCard';
import { renameDynamicMeasure } from '../../redux/DynamicMeasures/DynamicMeasuresActions';
import { formatChartLabelValue } from '../ChartOptions/Format/NumberFormatter';
import TableChart from '../Charts/TableChart/TableChart';
import '../DataViewer/dataViewerMiddle.css';
import WaterfallChart from '../Charts/WaterfallChart';
import { useDispatch } from 'react-redux';
import { initializeWaterfallState } from '../../redux/ChartPoperties/ChartControlsActions';
import { initializeDateFormatState } from '../../redux/ChartPoperties/ChartControlsActions';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import Tooltip from '@mui/material/Tooltip';
import { RootState } from '../../redux';
import useCombinedColorSchemes from '../../hooks/useCombinedColorSchemes';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FormattedQuery from './FormattedQuery';
import { checkMinRequiredCards } from '../ChartAxes/chartDataFunctions/checkMinRequiredCards';
import { AxisType } from '../CommonFunctions/aliases';
import Warning from '@mui/icons-material/WarningAmber';

import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import {
  extractFieldsData,
  getFieldNamesByAxis,
  getFieldUidsByAxis,
  multiFieldSort,
} from '../ChartOptions/Sort/reusableFunctions';
import { chartTypes } from '../ChartOptions/ChartTypeComponents/chartTypes';
import ExcelJS from 'exceljs';
const popoverButtonStyle = {
  textTransform: 'none',
  color: 'grey',
  display: 'block',
  width: '100%',
};

const GraphArea = ({
  // state
  tileState,
  tabState,
  tabTileProps,
  chartProperties,
  chartGroup,
  chartControlState,
  token,
  pageSettings,
  dashBoardGroup,
  dynamicMeasureState,
  calculations,
  chartControls,
  setMapJSON,
  setLoading,

  // dispatch
  setChartTitle,
  setGenerateTitleToStore,
  toggleGraphSize,
  updateQueryResult,
  updateMargin,
  setPageSettings,
  resetPageSettings,
  renameDynamicMeasure,
}: any) => {
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  const combinedThemes = useCombinedColorSchemes();
  const tabId = useSelector((state: RootState) => state.tabTileProps.selectedTabId);
  const defaultThemeId = useSelector(
    (state: RootState) => state.tabState.tabs[tabId]?.dashboardState.defaultThemeId,
  );

  const defaultThemeName = useMemo(() => {
    // If there is a defaultThemeId, try to find that theme
    let theme = defaultThemeId
      ? combinedThemes.find((t) => t.id === defaultThemeId || t.themeId === defaultThemeId)
      : undefined;

    // If no theme is found, fallback to the first theme in the array
    if (!theme && combinedThemes.length > 0) {
      theme = combinedThemes[0];
    }

    return theme?.name;
  }, [defaultThemeId, combinedThemes]);

  useEffect(() => {
      if (chartType === 'bubbleMap' || chartType === 'filledMap') {
        dispatch(updateLabelOption(propKey, 'showLabel', false));
      } else {
        dispatch(updateLabelOption(propKey, 'showLabel', true));
      }
    }, [chartProperties.properties[propKey]?.chartType, propKey]);

  const dimensionFieldsName: string[] = [
    AxisType.Row,
    AxisType.Column,
    AxisType.Dimension,
    AxisType.SplitBy,
    AxisType.Location,
  ];

  const dimensionAxisFields = useMemo(() => {
    return chartProperties.properties[propKey].chartAxes
      .filter((axis: any) => {
        return dimensionFieldsName.includes(axis.name);
      })
      .flatMap((axis: any) => axis.fields);
  }, [chartProperties.properties[propKey].chartAxes]);

  const measureFieldsName: string[] = [AxisType.Measure, AxisType.X, AxisType.Y];

  const measureAxisFields = useMemo(() => {
    return chartProperties.properties[propKey].chartAxes
      .filter((axis: any) => {
        return measureFieldsName.includes(axis.name);
      })
      .flatMap((axis: any) => axis.fields);
  }, [chartProperties.properties[propKey].chartAxes]);

  useEffect(() => {
    if (
      chartControls?.properties[propKey]?.rowSecurity?.filterPanels[
        chartControls?.properties?.[propKey]?.rowSecurity?.currentOperator?.toLowerCase()
      ]?.filters.length > 0 &&
      dimensionAxisFields.length === 0
    ) {
      const id =
        chartControls?.properties[propKey]?.rowSecurity?.filterPanels[
          chartControls?.properties?.[propKey]?.rowSecurity?.currentOperator?.toLowerCase()
        ]?.filters[0].source;
      dispatch(
        updateUserSelection(
          propKey,
          chartControls?.properties?.[propKey]?.rowSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(
        removeRowSecurityCard(
          propKey,
          id,
          chartControls?.properties?.[propKey]?.rowSecurity?.currentOperator?.toLowerCase(),
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }
  }, [dimensionAxisFields]);

  useEffect(() => {
    if (
      chartControls?.properties[propKey]?.columnSecurity?.filterPanels[
        chartControls?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase()
      ]?.filters.length > 0 &&
      measureAxisFields.length === 0
    ) {
      const id =
        chartControls?.properties[propKey]?.columnSecurity?.filterPanels[
          chartControls?.properties?.[propKey]?.columnSecurity?.currentOperator?.toLowerCase()
        ]?.filters[0].source;
      dispatch(
        updateUserSelectionColumn(
          propKey,
          chartControls?.properties?.[propKey]?.columnSecurity?.currentOperator.toLowerCase(),
          [],
        ),
      );
      dispatch(
        removeColumnSecurityCard(
          propKey,
          id,
          chartControls?.properties?.[propKey]?.columnSecurity?.currentOperator?.toLowerCase(),
        ),
      );
      dispatch(callQueryAPI(propKey, true));
    }
  }, [measureAxisFields]);

  const { tooltipFormats } = useSelector((state: RootState) => ({
    tooltipFormats: state.chartControls?.properties[propKey]?.formatOptions?.tooltipFormats,
  }));

  var selectedDynamicMeasureProp =
    dynamicMeasureState.dynamicMeasureProps?.[`${dynamicMeasureState.selectedTabId}`]?.[
      `${dynamicMeasureState.selectedTileId}`
    ]?.[`${dynamicMeasureState.selectedTileId}.${dynamicMeasureState.selectedDynamicMeasureId}`];
  const { graphAreaBackgroundColor, graphAreaBorderColor, color } = useMemo(() => {
    const activeTabId = tabTileProps.selectedTabId;
    if (!activeTabId) {
      return {
        graphAreaBackgroundColor: '#ffffff',
        graphAreaBorderColor: '#5e5e5e',
        color: '#ffffff',
      };
    }

    const tileSchemeName = chartControls.properties[propKey]?.colorScheme;

    const schemeNameToUse = tileSchemeName || defaultThemeName || 'peacock';

    const selectedScheme = combinedThemes.find((scheme) => scheme.name === schemeNameToUse);

    const background = selectedScheme ? selectedScheme.background : '#ffffff';
    const isDarkTheme = selectedScheme?.dark === true;

    return {
      graphAreaBackgroundColor: background,
      graphAreaBorderColor: isDarkTheme ? '#9e9b9bff' : '#bcb8b8ff',
      color: isDarkTheme ? '#ffffff' : '#5e5e5e',
    };
  }, [tabTileProps.selectedTabId, chartControls, combinedThemes, propKey, defaultThemeName]);

  const [backgroundColor, setBackgroundColor] = useState<string>('');
  const [fontColor, setFontColor] = useState<string>('');
  const [italicText, setItalicText] = useState<string>('');
  const [boldText, setBoldText] = useState<string>('');
  const [textUnderline, setTextUnderline] = useState<string>('');
  const [copyCommand, setCopyCommand] = useState<string | null>(null);
  //   const [hasUnMatched, setHasUnMatched] = useState(false);

  const showWarning = useMemo(
    () => chartControls.properties[propKey]?.chartErrorDetails,
    [chartControls.properties[propKey]?.chartErrorDetails],
  );
  const [showSqlQueryError, setShowSqlQueryError] = useState<string | null>(null);
  const [downloadError, setDownloadError] = useState<string | null>(null);

  const showRowSecurity = Object.values(
    chartControls.properties?.[propKey]?.rowSecurity?.filterPanels || {},
  ).some((panel: any) => Array.isArray(panel.filters) && panel.filters.length > 0);

  const showColumnSecurity = Object.values(
    chartControls.properties?.[propKey]?.columnSecurity?.filterPanels || {},
  ).some((panel: any) => Array.isArray(panel.filters) && panel.filters.length > 0);

  const rowPanels = chartControls.properties?.[propKey]?.rowSecurity?.filterPanels || {};
  const columnPanels = chartControls.properties?.[propKey]?.columnSecurity?.filterPanels || {};
  const fontFamilyForAllTiles =
    tabState.tabs[tabTileProps.selectedTabId]?.dashboardState?.fontFamilyForAllTiles;
  const selectedFontFamily = tabState.tabs[tabTileProps.selectedTabId]?.dashboardState?.fontFamily;
  const showImpersonation = [...Object.values(rowPanels), ...Object.values(columnPanels)].some(
    (panel: any) =>
      Array.isArray(panel.filters) &&
      panel.filters.length > 0 &&
      Array.isArray(panel.filters[0]?.userSelection) &&
      panel.filters[0].userSelection.some((val: any) => val !== ''),
  );

  const dispatch = useDispatch();

  if (chartControls.properties[propKey] && !chartControls.properties[propKey].waterfall) {
    dispatch(initializeWaterfallState(propKey));
  }

  const copyToClipboard = (text: string, command: string): void => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyCommand(command);
        setTimeout(() => {
          setCopyCommand(null);
        }, 3000);
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
      });
  };

  useEffect(() => {
    if (chartControls.properties[propKey] && chartControls.properties[propKey].formatOptions) {
      dispatch(initializeDateFormatState(propKey));
    }
  }, [propKey]);

  useEffect(() => {
    var formats = selectedDynamicMeasureProp?.conditionalFormats;

    if (formats?.length > 0) {
      for (let i = formats.length - 1; i >= 0; i--) {
        if (formats[i].isConditionSatisfied) {
          setBackgroundColor(formats[i].backgroundColor);
          setFontColor(formats[i].fontColor);
          setBoldText(formats[i].isBold ? 'bold' : 'normal');
          setItalicText(formats[i].isItalic ? 'italic' : 'normal');
          setTextUnderline(formats[i].isUnderlined ? 'underline' : 'none');
          return;
        }
        if (i === 0 && !formats[i].isConditionSatisfied) {
          setBackgroundColor(selectedDynamicMeasureProp?.styleOptions.backgroundColor);
          setFontColor(selectedDynamicMeasureProp?.styleOptions.fontColor);
          setBoldText(selectedDynamicMeasureProp?.styleOptions.isBold ? 'bold' : 'normal');
          setItalicText(selectedDynamicMeasureProp?.styleOptions.isItalic ? 'italic' : 'normal');
          setTextUnderline(
            selectedDynamicMeasureProp?.styleOptions.isUnderlined ? 'underline' : 'none',
          );
        }
      }
    } else {
      setBackgroundColor(selectedDynamicMeasureProp?.styleOptions.backgroundColor);
      setFontColor(selectedDynamicMeasureProp?.styleOptions.fontColor);
      setBoldText(selectedDynamicMeasureProp?.styleOptions.isBold ? 'bold' : 'normal');
      setItalicText(selectedDynamicMeasureProp?.styleOptions.isItalic ? 'italic' : 'normal');
      setTextUnderline(
        selectedDynamicMeasureProp?.styleOptions.isUnderlined ? 'underline' : 'none',
      );
    }
  }, [selectedDynamicMeasureProp]);

  const [graphDimension, setGraphDimension] = useState<any>({});
  const [graphDimension2, setGraphDimension2] = useState<any>({});
  const [editTitle, setEditTitle] = useState<boolean>(false);

  const [showSqlCode, setShowSqlCode] = useState<boolean>(false);
  const [fullScreen, setFullScreen] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<any>();

  // useEffect(() => {
  //   onUnMatchedChange?.(hasUnMatched);
  // }, [hasUnMatched, onUnMatchedChange]);

  useEffect(() => {
    if (!tabTileProps.showDash) {
      if (pageSettings.callForDownload) {
        onDownload();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSettings.callForDownload]);
  useEffect(() => {
    setFullScreen(pageSettings.fullScreen);
  }, [pageSettings.fullScreen]);

  useEffect(() => {
    if (chartProperties.properties[propKey].chartType === 'calendar') {
      if (chartControlState.properties[propKey].chartMargin.top < 13) {
        updateMargin(propKey, 'top', 13);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const graphDimensionCompute = () => {
    if (tileState.tiles[propKey]?.graphSizeFull) {
      const container = document.getElementById('graphContainer');
      let height = container ? (container as HTMLElement).clientHeight - 30 : 0;
      let width = container ? (container as HTMLElement).clientWidth - 30 : 0;
      // let height = (document.getElementById('graphContainer') as HTMLElement).clientHeight - 30;
      // const height = (document.getElementById("graphContainer") as HTMLElement).clientHeight;
      // const width = (document.getElementById("graphContainer") as HTMLElement).clientWidth;
      // let width = (document.getElementById('graphContainer') as HTMLElement).clientWidth - 30;
      setGraphDimension({
        height,
        width,
      });
    } else {
      if (chartProperties.properties[propKey].chartType === 'simplecard') {
        setGraphDimension({
          height:
            tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[propKey].height *
            tabTileProps.dashGridSize.y,
          width:
            tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[propKey].width *
            tabTileProps.dashGridSize.x,
        });
      } else {
        setGraphDimension({
          height:
            tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[propKey].height *
            tabTileProps.dashGridSize.y,
          width:
            tabState.tabs[tabTileProps.selectedTabId].dashTilesDetails[propKey].width *
            tabTileProps.dashGridSize.x,
        });
      }
    }
  };

  const graphDimensionCompute2 = () => {
    let height = (document.getElementById('graphFullScreen') as HTMLElement).clientHeight;
    let width = (document.getElementById('graphFullScreen') as HTMLElement).clientWidth;
    setGraphDimension2({
      height,
      width,
    });
  };

  useLayoutEffect(() => {
    function updateSize() {
      graphDimensionCompute();
      if (fullScreen) graphDimensionCompute2();
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fullScreen,
    tabTileProps.showDataViewerBottom,
    tabTileProps.selectedControlMenu,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    tileState.tiles[propKey]?.graphSizeFull,
    open,
    chartProperties.properties[propKey].chartType,
    chartProperties.properties[propKey].enableOverrideForUID,
  ]);

  const removeFullScreen = (e: any) => {
    if (e.keyCode === 27) {
      setFullScreen(false);
    }
  };

  const appliedFontFamily = fontFamilyForAllTiles ? selectedFontFamily : undefined;

  const chartDisplayed = () => {
    switch (chartProperties.properties[propKey].chartType) {
      case 'multibar':
        return (
          <MultiBarChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'waterfall':
        return (
          <WaterfallChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'stackedBar':
        return (
          <StackedBar
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'horizontalBar':
        return (
          <HorizontalBar
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'horizontalStacked':
        return (
          <Horizontalstacked
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'crossTab':
        return (
          <CrossTabChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'scatterPlot':
        return (
          <ScatterChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'area':
        return (
          <AreaChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'pie':
        return (
          <PieChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'donut':
        return (
          <DoughnutChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'rose':
        return (
          <RoseChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'line':
        return (
          <LineChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'funnel':
        return (
          <FunnelChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'gauge':
        return (
          <GaugeChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'heatmap':
        return (
          <HeatMap
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'filledMap':
        return (
          <FilledMap
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            setMapJSON={setMapJSON}
            setLoading={setLoading}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );

      case 'bubbleMap':
        return (
          <BubbleMap
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            setMapJSON={setMapJSON}
            setLoading={setLoading}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
            // unMatched={setHasUnMatched}
          />
        );
      case 'stackedArea':
        return (
          <StackedAreaChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'calendar':
        return (
          <CalendarChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'boxPlot':
        return (
          <BoxPlotChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'treeMap':
        return (
          <TreeMap
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'sankey':
        return (
          <Sankey
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'richText':
        if (chartProperties.properties[propKey].isDynamicMeasureWindowOpened) {
          var data = selectedDynamicMeasureProp?.dmValue;
          // var formattedValue = data;
          var formattedValue = formatChartLabelValue(selectedDynamicMeasureProp, data);

          return (
            <div
              style={{
                color: fontColor,
                backgroundColor: backgroundColor,
                fontStyle: italicText,
                fontWeight: boldText,
                textDecoration: textUnderline,

                padding: '5px',
                width: 'fit-content',
                overflow: 'hidden',
                margin: 'auto',
              }}
            >
              {data ? formattedValue : ''}
            </div>
          );
        } else {
          return (
            <TextEditor
              propKey={propKey}
              graphDimension={fullScreen ? graphDimension2 : graphDimension}
              colorScheme={defaultThemeName}
              // graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            />
          );
        }
      case 'simplecard':
        return (
          <SimpleCard
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      case 'table':
        return (
          <TableChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          ></TableChart>
        );
      case 'wordCloud':
        return (
          <WordCloudChart
            propKey={propKey}
            graphDimension={fullScreen ? graphDimension2 : graphDimension}
            graphTileSize={tileState.tiles[propKey]?.graphSizeFull}
            colorScheme={defaultThemeName}
            fontFamily={appliedFontFamily}
          />
        );
      default:
        return <h2>Work in progress</h2>;
    }
  };

  // ############################################
  // Setting title automatically
  // ############################################

  const graphTitle = () => {
    if (chartProperties.properties[propKey].titleOptions.generateTitle === 'Auto') {
      const chartAxes = chartProperties.properties[propKey].chartAxes;

      var dims: any[] = [];
      var measures: any[] = [];
      const chartType = chartProperties.properties[propKey].chartType;

      // Function to get the chart value from chart name
      const getChartValue = (chartType: string): string => {
        return chartTypes.find((chart) => chart.name === chartType)?.value.trim() ?? '';
      };

      const chartValue = getChartValue(chartType);
      const fallbackTitle = `Untitled ${chartValue}`;

      // Compile dimensions and measures of different chart types in one format
      switch (chartType) {
        case 'crossTab':
        case 'heatmap':
        case 'boxPlot':
          dims = dims.concat(chartAxes[1].fields);
          dims = dims.concat(chartAxes[2].fields);
          measures = measures.concat(chartAxes[3]?.fields);
          break;

        case 'scatterPlot':
          dims = dims.concat(chartAxes[1].fields);
          measures = measures.concat(chartAxes[2].fields);
          measures = measures.concat(chartAxes[3].fields);
          break;

        case 'gauge':
        case 'richText':
        case 'funnel':
        case 'simplecard':
          measures = measures.concat(chartAxes[1].fields);
          break;

        case 'multibar':
        case 'stackedBar':
        case 'horizontalBar':
        case 'horizontalStacked':
        case 'line':
        case 'area':
        case 'stackedArea':
        case 'bubbleMap':
          dims = dims.concat(chartAxes[1].fields);
          dims = dims.concat(chartAxes[2].fields);
          measures = measures.concat(chartAxes[3].fields);
          break;

        default:
          dims = dims.concat(chartAxes[1].fields);
          measures = measures.concat(chartAxes[2].fields);
          break;
      }

      var title = '';

      // Concatenate field names in dims / measures
      const concatenateFields = (fields: any) => {
        if (fields.length > 0) {
          var tempTitle = '';
          fields.forEach((element: any, index: number) => {
            if (index === 0) {
              let titlePart = element?.displayname;
              tempTitle = tempTitle + titlePart;
            }
            if (index > 0) {
              let titlePart: any = `, ${element?.displayname}`;
              tempTitle = tempTitle + titlePart;
            }
          });

          return tempTitle;
        }
      };

      const crossTabTitle = () => {
        let dimTitle = concatenateFields(dims.slice(0, 2));
        let measureTitle = concatenateFields(measures.slice(0, 2));
        if (dims.length > 2) {
          dimTitle += ' & others';
        }
        if (measures.length > 2) {
          measureTitle += ' & more ';
        } else if (measures.length > 0) {
          measureTitle += ' ';
        }
        if (measures.length && dims.length) {
          measureTitle += 'by ';
        }
        let title = `${measureTitle || ''}${dimTitle || ''}`.trim();
        return title || fallbackTitle;
      };

      var dimTitle = concatenateFields(dims);
      var measureTitle = concatenateFields(measures);

      if (chartType === 'gauge' || chartType === 'simplecard') {
        title = measureTitle ? measureTitle : fallbackTitle;
      } else if (chartType === 'funnel') {
        // Checking if atleast 2 measure fields are available
        title = measureTitle && chartAxes[1].fields.length >= 2 ? measureTitle : fallbackTitle;
      } else if (chartType === 'richText') {
        title = 'Title Rich Text';
      } else if (['crossTab', 'table'].includes(chartType)) {
        title = crossTabTitle();
      } else if (['boxPlot', 'scatterPlot', 'heatmap'].includes(chartType)) {
        // Checking if all the three axes has fields or not
        if (
          chartAxes[1].fields.length &&
          chartAxes[2].fields.length &&
          chartAxes[3].fields.length
        ) {
          title = measureTitle ? measureTitle : '';
          title = dimTitle ? (title ? title + ` by ${dimTitle}` : fallbackTitle) : fallbackTitle;
        } else {
          title = fallbackTitle;
        }
      } else if (chartType === 'sankey') {
        // Checking if both axes has fields and dimensions has 2 fields
        if (chartAxes[1].fields.length === 2 && chartAxes[2].fields.length) {
          title = measureTitle ? measureTitle : '';
          title = dimTitle ? (title ? title + ` by ${dimTitle}` : fallbackTitle) : fallbackTitle;
        } else {
          title = fallbackTitle;
        }
      } else if (
        [
          'multibar',
          'stackedBar',
          'horizontalBar',
          'horizontalStacked',
          'line',
          'area',
          'stackedArea',
        ].includes(chartType)
      ) {
        // Checking if dimension and measure has fields
        if (chartAxes[1].fields.length && chartAxes[3].fields.length) {
          title = measureTitle ? measureTitle : '';
          title = dimTitle ? (title ? title + ` by ${dimTitle}` : fallbackTitle) : fallbackTitle;
        } else {
          title = fallbackTitle;
        }
      } else if (chartType === 'bubbleMap') {
        // Checking if location and measure has fields
        if (chartAxes[2].fields.length && chartAxes[3].fields.length) {
          title = measureTitle ? measureTitle : '';
          title = dimTitle ? (title ? title + ` by ${dimTitle}` : fallbackTitle) : fallbackTitle;
        } else {
          title = fallbackTitle;
        }
      } else {
        title = measureTitle ? measureTitle : '';
        title = dimTitle ? (title ? title + ` by ${dimTitle}` : fallbackTitle) : fallbackTitle;
      }

      title = title.charAt(0).toUpperCase() + title.slice(1);

      setChartTitle(propKey, title);
    }
  };

  useEffect(() => {
    graphTitle();
  }, [
    chartProperties.properties[propKey].chartAxes,
    chartProperties.properties[propKey].titleOptions.generateTitle,
  ]);

  // ############################################
  // Manual title entry
  // ############################################

  const editTitleText = () => {
    // if (chartProperties.properties[propKey].generateTitle === "Manual") {
    setEditTitle(true);
    setGenerateTitleToStore(propKey, 'Manual');
    // }
  };

  useEffect(() => {
    // if (chartProperties.properties[propKey].chartType === "richText") {
    // 	setTitleText(selectedDynamicMeasureProp?.editedDynamicMeasureName);
    // } else {
    setTitleText(chartProperties.properties[propKey].titleOptions.chartTitle);
    //}
  }, [chartProperties.properties[propKey].titleOptions.chartTitle]);

  const [inputTitleText, setTitleText] = useState<string>('');
  const handleTitleChange = (e: any) => {
    setTitleText(e.target.value);
  };

  const completeRename = () => {
    // if (chartProperties.properties[propKey].chartType === "richText") {
    // 	renameDynamicMeasure(inputTitleText);
    // } else {
    setChartTitle(propKey, inputTitleText);
    //	}
    setEditTitle(false);
  };

  const ShowFormattedQuery = () => {
    var query = chartControlState.properties[propKey].queryResult;

    const customStyles = {
      hljs: {
        color: 'gray',
        background: '#f5f5f5',
        padding: 5,
      },
    };

    return (
      <div style={{ position: 'relative', borderRadius: 10 }}>
        <div
          className="copy-container"
          style={{
            position: 'absolute',
            top: '15px',
            right: '13px',
            cursor: 'pointer',
            zIndex: 10,
          }}
          onClick={() => copyToClipboard(query, 'Copied')}
        >
          {copyCommand === 'Copied' ? (
            <div className="copied">
              <img className="tick-icon" src="/tick-icon.png" alt="Tick Icon" />
              <span>copied</span>
            </div>
          ) : (
            <div className="copy">
              <img src="/copy-image.png" alt="Copy Icon" />
              <span>copy</span>
            </div>
          )}
        </div>

        <SyntaxHighlighter
          className="syntaxHighlight"
          language="sql"
          style={customStyles}
          showLineNumbers={true}
          wrapLines={true}
          lineProps={{ style: { wordBreak: 'break-word', whiteSpace: 'pre-wrap' } }}
        >
          {query ? query : null}
        </SyntaxHighlighter>
      </div>
    );
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const RenderScreenOption = () => {
    return (
      <>
        <div
          className={
            !tileState.tiles[propKey]?.graphSizeFull ? 'graphAreaIconsSelected' : 'graphAreaIcons'
          }
          title="Match Dashboard Size"
          style={
            tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.includes(propKey)
              ? {}
              : { cursor: 'not-allowed' }
          }
          onClick={() => {
            if (tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.includes(propKey))
              toggleGraphSize(propKey, false);
          }}
        >
          <FullscreenExitIcon />
        </div>

        <div
          className={
            tileState.tiles[propKey]?.graphSizeFull ? 'graphAreaIconsSelected' : 'graphAreaIcons'
          }
          title="Fit Tile Size"
          onClick={() => toggleGraphSize(propKey, true)}
        >
          <FullscreenIcon />
        </div>
      </>
    );
  };

  const chartErrorDetails = (propKey: string, error: any) => {
    dispatch(storeErrorDetails(propKey, error));
  };

  const removeExtraMeasureField = (propKey: string) => {
    dispatch(resetExtraMeasureField(propKey));
  };

  const getSqlQuery = () => {
    const savedCalculations = calculations?.savedCalculations;

    getChartData(
      chartProperties.properties[propKey].chartAxes,
      chartProperties,
      chartControls,
      chartGroup,
      tabTileProps.tablesForSelectedDataSets,
      dashBoardGroup,
      propKey,
      'Chartaxes',
      token,
      chartProperties.properties[propKey].chartType,
      undefined,
      undefined,
      true,
      savedCalculations,
      undefined,
      chartErrorDetails,
      tooltipFormats,
      removeExtraMeasureField,
    ).then(async (data) => {
      var url: string = '';
      if (chartProperties.properties[propKey].selectedDs.isFlatFileData) {
        url = `query?datasetid=${chartProperties.properties[propKey].selectedDs.id}`;
      } else {
        url = `query?dbconnectionid=${chartProperties.properties[propKey].selectedDs.connectionId}&datasetid=${chartProperties.properties[propKey].selectedDs.id}&workspaceId=${chartProperties.properties[propKey].selectedDs.workSpaceId}`;
      }
      var res: any = await FetchData({
        requestType: 'withData',
        method: 'POST',
        url: `${url}&sql=true`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: data,
      });
      console.log(res);
      if (res.status) {
        updateQueryResult(propKey, res.data);
        setShowSqlCode(true);
      } else {
        // window.alert('Error in getting sql Query');
        setShowSqlQueryError('Error in getting sql Query');
      }
    });
  };

  /* 
  *************************************************
  ON DOWNLOAD EXCEL FILE
  *************************************************
  */

  const chartData = chartControls?.properties[propKey].chartData;
  const mapType = chartProperties?.properties[propKey].chartType;
  const exportToExcel = async (data: any[]) => {
    // Apply filtering only for "Filled Map" and "Bubble Map"
    const filteredData =
      mapType === 'filledMap' || mapType === 'bubbleMap'
        ? data.map((row) => {
            const newRow: any = {};
            Object.keys(row).forEach((key) => {
              if (!(key === 'selectedKey' && row[key] === '')) {
                newRow[key] = row[key];
              }
            });
            return newRow;
          })
        : data;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    const timestamp = new Date().toLocaleString().replace(/[/:,\s]/g, '_');
    const title = chartProperties?.properties[propKey].titleOptions?.chartTitle;
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    if (filteredData.length > 0) {
      // Add header row
      worksheet.columns = Object.keys(filteredData[0]).map((key) => ({
        header: key,
        key: key,
      }));

      // Add data rows
      filteredData.forEach((row) => {
        worksheet.addRow(row);
      });
    }
    // const excelBuffer = XLSX.write(workbook, {
    //   bookType: 'xlsx',
    //   type: 'array',
    // });
    const excelBuffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${title}_${timestamp}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  /* 
  *************************************************
  ON DOWNLOAD PDF & ON DOWNLOAD IMAGE
  *************************************************
  */

  const getHeightAndWidth = (paperHeight: number, paperWidth: number) => {
    var graphHeight = graphDimension2.height;
    var graphWidth = graphDimension2.width;

    const pageHeight = paperHeight - (pageSettings.top_margin + pageSettings.bottom_margin);
    const pageWidth = paperWidth - (pageSettings.right_margin + pageSettings.left_margin);
    var heightRatio = pageHeight / graphHeight;
    var widthRatio = pageWidth / graphWidth;

    // getting least value
    var ratio = Math.min(heightRatio, widthRatio);

    var finalHeight = graphHeight * ratio;
    var finalWidth = graphWidth * ratio;

    return { height: finalHeight, width: finalWidth };
  };

  // function calls when click on the download button after changing pagesettings(orientation,format,ppi)
  // changed htmlToCanvas to toPng as we doing in dashboard download also
  const onDownload = async () => {
    // getting  HTML element (chart in fullscreen) as a value in variable
    const input = document.getElementById('graphFullScreen') as HTMLElement;

    if (!input) {
      setDownloadError('Some Error occoured while downloading. Please try again later');
      return;
    }

    // Generate filename
    const d = new Date();
    const id = `${tabTileProps.selectedTileName}_${d.getDate()}${
      d.getMonth() + 1
    }${d.getFullYear()}:${d.getHours()}${d.getMinutes()}${d.getSeconds()}`;

    // Slight delay to ensure rendering is complete
    await new Promise((resolve) => setTimeout(resolve, 500));

    //default options for toPng
    const toPngOptions = {
      cacheBust: false,
      fontEmbedCSS: '',
      backgroundColor: '#ffffff',
      pixelRatio: 2,
      style: {
        overflow: 'visible',
        maxHeight: 'none',
        height: 'auto',
      },
    };

    if (pageSettings.downloadType === 'pdf') {
      // --- PDF DOWNLOAD ---
      toPng(input, toPngOptions)
        .then((imageData: any) => {
          const pdf = new jsPDF(
            pageSettings.SelectedOrientation,
            'px',
            pageSettings.selectedFormat,
          );
          var width = pdf.internal.pageSize.getWidth();
          var height = pdf.internal.pageSize.getHeight();
          const heightAndWidth = getHeightAndWidth(height, width);

          pdf.addImage(
            imageData,
            'PNG',
            pageSettings.left_margin,
            pageSettings.top_margin,
            heightAndWidth.width,
            heightAndWidth.height,
          );
          pdf.save(`${id}.pdf`);

          setFullScreen(false);
          setPageSettings('fullScreen', false);
          setPageSettings('openPageSettingPopover', false);
          setTimeout(() => {
            resetPageSettings();
          }, 300);
        })
        .catch((err) => {
          setDownloadError('PDF generation failed. Please try again.');
          setFullScreen(false);
          setPageSettings('fullScreen', false);
          resetPageSettings();
        });
    } else {
      // --- IMAGE DOWNLOAD ---
      toPng(input, toPngOptions)
        .then((dataUrl: any) => {
          const link = document.createElement('a');
          link.download = `${id}.png`;
          link.href = dataUrl;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          setPageSettings('openPageSettingPopover', false);
          setPageSettings('fullScreen', false);
          setFullScreen(false);
          setTimeout(() => {
            resetPageSettings();
          }, 300);
        })
        .catch((err: any) => {
          setDownloadError('Image download failed. Please try again.');
          setFullScreen(false);
          setPageSettings('fullScreen', false);
          resetPageSettings();
        });
    }
  };
  // to hide the edit icon while no data is there on the axes
  const chartType = chartProperties.properties[propKey].chartType;
  const enableEdit =
    !!chartProperties.properties[propKey]?.titleOptions?.chartTitle ||
    chartProperties.properties[propKey]?.titleOptions?.generateTitle === 'Manual' ||
    checkMinRequiredCards(chartProperties.properties[propKey], chartType);

  const fontSize = chartProperties.properties[propKey].isDynamicMeasureWindowOpened
    ? selectedDynamicMeasureProp?.fontSize
    : chartProperties.properties[propKey].titleOptions.fontSize;

  const sortConfigurations = chartControls.properties[propKey]?.sortConfigurations || [];
  const chartAxes = chartProperties.properties[propKey].chartAxes;
  const rowFieldNames = getFieldNamesByAxis(chartAxes, 'Row');
  const columnFieldNames = getFieldNamesByAxis(chartAxes, 'Column');
  const measureFieldUids = getFieldUidsByAxis(chartAxes, 'Measure');
  const dimensionFieldNames = getFieldNamesByAxis(chartAxes, 'Dimension');
  const splitByFieldNames = getFieldNamesByAxis(chartAxes, 'Split By');

  useEffect(() => {
    const data =
      chartControls.properties[propKey].chartData.length > 0
        ? chartControls.properties[propKey].chartData
        : [];

    const rowFieldsData = extractFieldsData(data, rowFieldNames);
    const columnFieldsData = extractFieldsData(data, columnFieldNames);

    let result = multiFieldSort({
      data,
      sortConfigurations,
      chartProperties,
      propKey,
      rowFieldsData,
      columnFieldsData,
      rowFieldNames,
      columnFieldNames,
      dimensionFieldNames,
      splitByFieldNames,
      measureFieldUids,
    });

    dispatch(updateChartData(propKey, result));
  }, [chartProperties.properties[propKey].chartAxes]);

  return (
    <div className="centerColumn" id="centerColumn">
      <div
        className="graphTitleAndEdit"
        style={{
          backgroundColor: graphAreaBackgroundColor,
        }}
      >
        {/* TODO: read this to re-implement name editing */}
        {editTitle ? (
          <form
            style={{
              width: '100%',
              fontSize: chartProperties.properties[propKey].titleOptions.fontSize,
            }}
            onSubmit={(evt: any) => {
              evt.currentTarget.querySelector('input').blur();
              evt.preventDefault();
            }}
          >
            <input
              autoFocus
              style={{
                fontFamily: appliedFontFamily,
                fontSize: chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                  ? '25px'
                  : chartProperties.properties[propKey].titleOptions.fontSize,

                textAlign: chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                  ? 'left'
                  : chartProperties.properties[propKey].titleOptions.titleAlign,
                backgroundColor: graphAreaBackgroundColor,
                paddingLeft: chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                  ? selectedDynamicMeasureProp?.titleLeftPadding
                  : chartProperties.properties[propKey].titleOptions.titleLeftPadding,
              }}
              type="text"
              className="editTitle"
              data-testid="chart-name-edit-input"
              value={inputTitleText}
              onChange={handleTitleChange}
              onBlur={() => completeRename()}
            />
          </form>
        ) : (
          <>
            <div
              className="graphTitle"
              style={{
                fontSize: fontSize,
                fontFamily: appliedFontFamily,
                textAlign: chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                  ? selectedDynamicMeasureProp?.titleAlign
                  : chartProperties.properties[propKey].titleOptions.titleAlign,
                paddingLeft: chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                  ? selectedDynamicMeasureProp?.titleLeftPadding
                  : chartProperties.properties[propKey].titleOptions.titleLeftPadding,
              }}
              onDoubleClick={() => editTitleText()}
              data-testid="chart-name-text"
              title="Double click to set title manually"
            >
              {chartProperties.properties[propKey].isDynamicMeasureWindowOpened
                ? selectedDynamicMeasureProp?.dynamicMeasureName
                : chartProperties.properties[propKey]?.titleOptions?.chartTitle}
              {enableEdit && (
                <EditOutlinedIcon
                  className="editIcon"
                  onClick={() => editTitleText()}
                  data-testid="chart-name-edit-icon"
                  titleAccess="Edit title"
                  style={{
                    fontSize: fontSize,
                    marginLeft: 6,
                    cursor: 'pointer',
                    color: color,
                    paddingTop: fontSize > 10 ? '5px' : '0px',
                  }}
                />
              )}
            </div>
          </>
        )}

        {showImpersonation && (
          <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
            <Tooltip title="Impersonation is applied">
              <GroupOutlinedIcon
                style={{
                  color: '#808080',
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            </Tooltip>
          </div>
        )}
        {/* {!showWarning && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              marginRight: '0.5rem',
              cursor: 'pointer',
            }}
            onClick={() => dispatch(callQueryAPI(propKey, true))}
          >
            <Tooltip
              arrow
              placement="top"
              title="Refresh data"
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <Autorenew sx={{ color: color, ':hover': { color: '#2BB9BB' } }} />
            </Tooltip>
          </div>
        )} */}
        {showWarning && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyItems: 'center',
              marginRight: '0.5rem',
            }}
          >
            <Tooltip
              arrow
              placement="top"
              title={
                'This chart cannot be rendered because one or more required fields are missing from the dataset. Please update the dataset to include the missing fields or edit the chart settings to use available fields.'
              }
              slotProps={{
                tooltip: {
                  sx: {
                    fontSize: '12px',
                  },
                },
              }}
            >
              <Warning
                style={{
                  color: '#850000ff',
                  flexShrink: 0,
                }}
                fontSize="small"
              />
            </Tooltip>
          </div>
        )}
        {(showRowSecurity || showColumnSecurity) && (
          <div style={{ display: 'flex', alignItems: 'center', justifyItems: 'center' }}>
            <Tooltip
              title={
                showRowSecurity && showColumnSecurity
                  ? 'Dimension and Measure Level Control is applied'
                  : showRowSecurity
                    ? 'Dimension Level Control is applied'
                    : showColumnSecurity
                      ? 'Measure Level Control is applied'
                      : ''
              }
            >
              <LockOutlinedIcon
                style={{
                  color: '#808080',
                  display: 'flex',
                  alignItems: 'center',
                }}
              />
            </Tooltip>
          </div>
        )}
        {showSqlCode ? (
          <div
            className="graphAreaIcons"
            onClick={() => {
              setShowSqlCode(false);
            }}
            title="View graph"
          >
            <BarChartIcon />
          </div>
        ) : (
          <>
            {!pageSettings.callForDownload &&
            chartProperties?.properties[propKey].chartType !== 'richText' &&
            !chartProperties.properties[propKey].isDynamicMeasureWindowOpened &&
            chartData &&
            chartData.length > 0 ? (
              <div className="graphAreaIcons">
                <MoreVertOutlined
                  sx={{ color: color }}
                  onClick={(e: any) => {
                    if (chartProperties?.properties[propKey].chartType === 'richText') return;

                    setOpen(true);
                    setAnchorEl(e.currentTarget);
                  }}
                />
              </div>
            ) : null}
          </>
        )}
      </div>

      {!fullScreen && (
        <div
          id="graphContainer"
          className="graphContainer"
          style={{
            margin: tileState.tiles[propKey]?.graphSizeFull ? '0' : '1rem',
            paddingTop: '0',
            backgroundColor: graphAreaBackgroundColor,
            overflow:
              chartProperties.properties[propKey].chartType === 'crossTab' ||
              chartProperties.properties[propKey].chartType === 'table'
                ? 'visible'
                : 'auto',
          }}
        >
          {chartDisplayed()}
          <FormattedQuery
            chartControlState={chartControlState}
            propKey={propKey}
            open={showSqlCode}
            onClose={() => setShowSqlCode(false)}
          />
        </div>
      )}

      {/* <ChartThemes /> */}

      {fullScreen && (
        <div
          // to set focus on graphFullScreen div
          ref={(element) => {
            if (element) {
              element.focus();
            }
          }}
          tabIndex={0}
          id="graphFullScreen"
          className="graphFullScreen"
          onKeyDown={(e) => {
            removeFullScreen(e);
            setPageSettings('fullScreen', false);
          }}
          style={{ padding: '0.7rem 0', zIndex: 10 }}
        >
          <div id="headline" style={{ display: 'flex' }}>
            <span
              className="graphTitle"
              style={{
                fontSize: chartProperties.properties[propKey].titleOptions.fontSize,
              }}
              onDoubleClick={() => editTitleText()}
            >
              {chartProperties.properties[propKey].titleOptions.chartTitle}
            </span>

            <OpenInFullIcon
              sx={{
                marginY: '0.25rem',
                marginX: '0.7rem',
                display: pageSettings.callForDownload ? 'none' : '',
                cursor: 'pointer',
              }}
              onClick={() => {
                setFullScreen(false);
                setPageSettings('fullScreen', false);
              }}
            />
          </div>

          {chartDisplayed()}
        </div>
      )}
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={() => setOpen(false)}
      >
        <Button
          sx={{ ...popoverButtonStyle }}
          style={
            tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.includes(propKey)
              ? {}
              : { cursor: 'not-allowed' }
          }
          value="Match Dashboard Size"
          onClick={() => {
            if (tabState.tabs[tabTileProps.selectedTabId].tilesInDashboard.includes(propKey))
              toggleGraphSize(propKey, false);
            setOpen(false);
          }}
        >
          <div className="screenSettingsMenuItems">
            <FullscreenExitIcon sx={{ fontSize: '20px' }} />
            Match Dashboard Size
            <div
              style={{
                visibility: !tileState.tiles[propKey]?.graphSizeFull ? 'visible' : 'hidden',
                marginLeft: 'auto',
                marginRight: '0px',
              }}
            >
              <DoneIcon sx={{ fontSize: '16px' }} />
            </div>
          </div>
        </Button>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="Fit Tile Size"
          onClick={() => {
            toggleGraphSize(propKey, true);
            setOpen(false);
          }}
        >
          <div className="screenSettingsMenuItems">
            <FullscreenIcon sx={{ fontSize: '20px' }} />
            Fit Tile Size
            <div
              style={{
                visibility: tileState.tiles[propKey]?.graphSizeFull ? 'visible' : 'hidden',
                marginLeft: 'auto',
                marginRight: '0px',
              }}
            >
              <DoneIcon sx={{ fontSize: '16px' }} />
            </div>
          </div>
        </Button>
        <hr
          style={{
            border: '1px solid rgba(224,224,224,1)',
            margin: 'auto 5px',
            borderRadius: '5px',
          }}
        ></hr>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="Full Screen"
          onClick={() => {
            setFullScreen(true);
            setPageSettings('fullScreen', true);
            setOpen(false);
          }}
        >
          <div className="screenSettingsMenuItems">
            <OpenInFullIcon sx={{ fontSize: '16px' }} />
            Show full screen
          </div>
        </Button>
        <hr
          style={{
            border: '1px solid rgba(224,224,224,1)',
            margin: 'auto 5px',
            borderRadius: '5px',
          }}
        ></hr>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="View SQL"
          onClick={() => {
            getSqlQuery();
            setOpen(false);
          }}
        >
          <div className="screenSettingsMenuItems">
            <img src={sqlIcon} alt="" className="graphAreaViewSqlButtonStyle" />
            View sql
          </div>
        </Button>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="Export Excel"
          // onClick={() => {
          //   setFullScreen(true);
          //   setPageSettings("fullScreen", true);
          //   setOpen(false);
          // }}
          onClick={() => {
            exportToExcel(chartData);
          }}
          disabled={!chartData}
        >
          <div className="screenSettingsMenuItems">
            {/* <FileDownloadIcon sx={{ fontSize: "16px" }} /> */}
            <AiFillFileExcel style={{ fontSize: '16px', marginTop: '1px' }} />
            Export Excel
          </div>
        </Button>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="pdf"
          onClick={() => {
            setPageSettings('downloadType', 'pdf');
            setPageSettings('fullScreen', true);
            setOpen(false);
            setPageSettings('openPageSettingPopover', true);
          }}
        >
          <div className="screenSettingsMenuItems">
            <PictureAsPdfIcon sx={{ fontSize: '16px' }} />
            Download PDF
          </div>
        </Button>
        <Button
          sx={{ ...popoverButtonStyle }}
          value="image"
          onClick={() => {
            setPageSettings('downloadType', 'image');
            setOpen(false);
            setPageSettings('fullScreen', true);
            setPageSettings('openPageSettingPopover', true);
          }}
        >
          <div className="screenSettingsMenuItems">
            <PhotoSizeSelectActualIcon sx={{ fontSize: '16px' }} />
            Download Image
          </div>
        </Button>
      </Popover>
      {pageSettings.openPageSettingPopover && pageSettings.fullScreen && <DownloadPagePopover />}

      {/* to show warning while sql query api failed */}
      {showSqlQueryError && (
        <NotificationDialog
          onCloseAlert={() => setShowSqlQueryError(null)}
          severity={'error'}
          testMessage={showSqlQueryError ?? 'Error in getting sql Query'}
          openAlert={!!showSqlQueryError}
        />
      )}

      {/* this added so that if download fails then show error */}
      {downloadError && (
        <NotificationDialog
          onCloseAlert={() => setDownloadError(null)}
          severity={'error'}
          testMessage={downloadError}
          openAlert={!!downloadError}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    tileState: state.tileState,
    tabState: state.tabState,
    tabTileProps: state.tabTileProps,
    chartControlState: state.chartControls,
    chartProperties: state.chartProperties,
    chartGroup: state.chartFilterGroup,
    token: state.isLogged.accessToken,
    pageSettings: state.pageSettings,
    dynamicMeasureState: state.dynamicMeasuresState,
    dashBoardGroup: state.dashBoardFilterGroup,
    calculations: state.calculations,
    chartControls: state.chartControls,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    setChartTitle: (propKey: string, title: string) => dispatch(setChartTitle(propKey, title)),
    renameDynamicMeasure: (name: string) => dispatch(renameDynamicMeasure(name)),
    setGenerateTitleToStore: (propKey: string, option: any) =>
      dispatch(setGenerateTitle(propKey, option)),
    toggleGraphSize: (tileKey: string, graphSize: boolean | any) =>
      dispatch(toggleGraphSize(tileKey, graphSize)),
    updateQueryResult: (propKey: string, query: string | any) =>
      dispatch(updateQueryResult(propKey, query)),
    updateMargin: (propKey: string, option: string, value: any) =>
      dispatch(updateChartMargins(propKey, option, value)),
    setPageSettings: (option: string, value: any) => dispatch(setPageSettings(option, value)),
    resetPageSettings: () => dispatch(resetPageSettings()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GraphArea);
